export const GnreJobStatus = {
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  NO_ACTIVE_JOB: 'NO_ACTIVE_JOB',
} as const;

export type GnreJobStatusType = typeof GnreJobStatus[keyof typeof GnreJobStatus];

export interface GnreJobStep {
  name: string;
  status: 'pending' | 'running' | 'completed' | 'failed';
  message?: string;
  startedAt?: string;
  completedAt?: string;
}

export interface GnreJobProgressDto {
  jobId: string;
  status: GnreJobStatusType;
  currentStep: number;
  totalSteps: number;
  steps: GnreJobStep[];
  initiatedBy?: { userId: string; userName: string; userEmail: string };
  startTime: string;
  lastUpdate: string;
  error?: string;
}

export interface GnreProgressResponse {
  jobs: GnreJobProgressDto[];
}
